<div>
  <ngx-spinner size="medium" color="#fff" [type]="typeSelected" [fullScreen]="true"> </ngx-spinner>
</div>
<div
  *ngrxLet="sharedFacade.isLoaded$ as dataLoaded"
  [ngClass]="{ loaderwrapper: !dataLoaded && submitted }"
>
  <div class="registerPage">
    <div class="logo">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6">
            <div class="logo-main">
              <div>
                <img src="/assets/images/Piqet_NewLogo.svg" alt="Logo" width="135" height="80" />
              </div>
              <div class="rightside-text">
                <div class="logo1">
                  Powering your <br />
                  sustainability journey
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="!isImageValid">
      <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
      <span class="sr-only">Error:</span>
      <i class="bi bi-exclamation-circle-fill"></i>
      <span id="PiqetValidationSummary" class="field-validation-error" style="margin-left: 5px"
        >Only .jpg,.png,.jpeg file allowed</span
      >
    </div>

    <div>
      <form [formGroup]="registerForm">
        <div class="content">
          <!-- Country & Plan dropdown -->
          <div class="row" *ngIf="!isTrial">
            <div class="col-sm-6">
              <div class="form-group required">
                <label
                  *ngIf="registerForm.get('Country')?.value || registerForm.get('PlanName')?.value"
                  class="sub-header-drpdown pb-2"
                  >Country</label
                >
                <ng-container *ngrxLet="sharedFacade.countryList$ as countries">
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #select
                    [items]="countries"
                    [searchable]="false"
                    formControlName="Country"
                    bindLabel="name"
                    [searchFn]="commonInputSearch"
                    (change)="onChange($event)"
                    placeholder="Country *"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          class="form-control search-input dropdown-search-design"
                          type="text"
                          id="inputValidation"
                          (input)="select.filter($any($event.target).value)"
                          placeholder="Search..."
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </ng-container>
                <div *ngIf="submitted && registerForm.get('Country')?.invalid" class="input-error">
                  {{ 'Country is required' }}
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <div class="form-group">
                  <label
                    *ngIf="
                      registerForm.get('PlanName')?.value || registerForm.get('Country')?.value
                    "
                    class="sub-header-drpdown pb-2"
                    >Plans</label
                  >
                  <ng-container *ngrxLet="sharedFacade.planList$ as plans">
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #plan
                      [items]="plans"
                      [searchable]="false"
                      formControlName="PlanName"
                      bindLabel="name"
                      [searchFn]="commonInputSearch"
                      placeholder="Choose plan"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control search-input dropdown-search-design"
                            id="inputValidation"
                            (input)="plan.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </ng-container>
                  <div
                    *ngIf="submitted && registerForm.get('PlanName')?.invalid"
                    class="input-error"
                  >
                    {{ 'Plan is required' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- User Details Title -->
          <div style="padding: 2px">
            <h4 style="margin: 20px 0 15px">Enter user details:</h4>
          </div>

          <div class="row">
            <!-- First name -->
            <div class="col-sm-6">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="Firstname"
                  [control]="registerForm.get('Firstname')"
                  label="First name"
                  placeholder="First name"
                  [submitted]="submitted"
                  [errorMessages]="{
                    minlength: 'First name must be at least 2 characters long'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>

            <!-- Last Name -->
            <div class="col-sm-6">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="Lastname"
                  [control]="registerForm.get('Lastname')"
                  label="Last name"
                  placeholder="Last name"
                  [submitted]="submitted"
                  [errorMessages]="{
                    minlength: 'Last name must be at least 2 characters long'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>

            <!-- Email -->
            <div class="col-sm-12">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="email"
                  [control]="registerForm.get('email')"
                  label="Email"
                  placeholder="Email"
                  [maxLength]="150"
                  [submitted]="submitted"
                  [inputType]="'email'"
                  (customBlur)="getEmailValidation()"
                  (inputEvent)="changeEmail($event)"
                  [errorMessages]="{
                    required: 'The email field is required.',
                    email: 'Invalid email address'
                  }"
                >
                </piqet-angular-common-input>
                <div
                  *ngIf="registerForm.get('email')?.valid && isEmailValid && !!currentEmail"
                  class="input-error"
                >
                  {{ currentEmail }} is already taken.
                </div>
              </div>
            </div>

            <!-- Password -->
            <div class="col-sm-6">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="Password"
                  [control]="registerForm.get('Password')"
                  label="Password"
                  placeholder="Password"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [inputType]="'password'"
                  [showPasswordToggle]="true"
                  (keyupEvent)="validationsPassword()"
                  [errorMessages]="{
                    required: 'The password field is required.'
                  }"
                >
                </piqet-angular-common-input>
                <div class="security-tabs">
                  <p [ngClass]="upperCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One uppercase character
                  </p>
                  <p [ngClass]="lowerCaseCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One lowercase character
                  </p>
                  <p [ngClass]="numberCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One number
                  </p>
                  <p [ngClass]="specialCharactersflag ? 'hightlightText' : 'NonhightlightText'">
                    One special character
                  </p>
                  <p [ngClass]="minLengthsflag ? 'hightlightText' : 'NonhightlightText'">
                    8 characters minimum
                  </p>
                </div>
              </div>
            </div>

            <!-- Confirm password -->
            <div class="col-sm-6">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="ConfirmPassword"
                  [control]="registerForm.get('ConfirmPassword')"
                  label="Confirm password"
                  placeholder="Confirm Password"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [inputType]="'password'"
                  [showPasswordToggle]="true"
                  [errorMessages]="{
                    required: 'The confirm password field is required.',
                    mustMatch: 'The password and confirm password fields do not match'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>

            <!-- Organization -->
            <div class="col-sm-12">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="OrganisationName"
                  [control]="registerForm.get('OrganisationName')"
                  label="Organization"
                  placeholder="Organization"
                  [submitted]="submitted"
                  (keypressEvent)="preventSemicolon($event)"
                >
                </piqet-angular-common-input>
                <div class="input-error" *ngIf="!checkValidationForOrg?.data">
                  {{ checkValidationForOrg?.message }}
                </div>
              </div>
            </div>
            <!-- Address -->
            <div class="col-sm-12" *ngIf="!isTrial">
              <div class="form-group required textarea">
                <div class="services-form desc">
                  <textarea
                    class="registerTextArea"
                    formControlName="address"
                    cols="20"
                    id="addressId"
                    name="address"
                    rows="2"
                    placeholder="Address"
                  ></textarea>
                  <label>Address</label>
                  <div
                    *ngIf="submitted && registerForm.get('address')?.invalid"
                    class="input-error"
                  >
                    Address is required.
                  </div>
                </div>
              </div>
            </div>

            <!-- Organization logo -->
            <div class="col-sm-12" *ngIf="!isTrial">
              <div class="form-group">
                <div>
                  <h4>Organization logo</h4>
                </div>
                <piqet-angular-file-upload
                  #fileUploadComponent
                  type="image"
                  [customConfig]="{
                    acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
                    acceptAttribute: '.png, .jpg, .jpeg',
                    maxFileSize: 5,
                    selectButtonText: 'Select file',
                    changeButtonText: 'Change',
                    removeButtonText: 'Remove',
                    showPreview: false,
                    isShowFullWidth: true,
                    placeholderText: 'Select organization logo',
                    customErrorMessage: 'Only .jpg,.png,.jpeg file allowed'
                  }"
                  [existingFileUrl]="imagePreview"
                  [existingFileName]="displayFileName"
                  [isImageValid]="isImageValid"
                  (fileSelected)="onFileSelected($event)"
                  (removeConfirmation)="removeImage()"
                >
                </piqet-angular-file-upload>
              </div>
            </div>

            <!-- Agreement checkbox -->
            <div class="col-7 checkbox form-group">
              <div class="noticeoffers checkBoxAlienMent">
                <div>
                  <input
                    type="checkbox"
                    class="chkOverview"
                    formControlName="IsAgree"
                    [ngClass]="{
                      'is-invalid': isChecked && registerForm.controls['IsAgree'].errors
                    }"
                  />
                </div>
                <div class="agreed-terms">
                  <span class="checkbox-text"> I've read and agreed to the </span
                  ><span class="checkbox-text pointer"
                    ><a id="terms-txt" (click)="openTermsPdf()"
                      >terms of use, privacy notice, and offer details.</a
                    ></span
                  >
                </div>
              </div>
              <div
                *ngIf="isChecked && registerForm.controls['IsAgree'].errors"
                [ngClass]="isChecked && registerForm.controls['IsAgree'].errors ? 'mt-3' : ''"
                class="input-error col-sm-12"
              >
                You have to agree with terms and conditions of purchase.
              </div>
            </div>

            <div
              [ngStyle]="{
                'margin-bottom':
                  isChecked && registerForm.controls['IsAgree'].errors ? '4.188rem' : ''
              }"
              class="col-sm-5 d-flex align-items-center form-group"
              *ngIf="!isTrial"
            >
              <div class="noticeoffers checkBoxAlienMent">
                <div>
                  <input
                    type="checkbox"
                    class="chkOverview"
                    checked="true"
                    (change)="updateConsent($event)"
                  />
                </div>
                <div class="agreed-terms">
                  <span class="checkbox-text"
                    >Consent to use of name and logo in marketing materials</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 currencyTab required">
              <div class="project-spacing currency-drpdown">
                <label *ngIf="sourceType" class="sub-header-drpdown pb-2"
                  >Where did you hear about PIQET from?</label
                >
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #currency
                  [items]="signUpSourceList"
                  (change)="selectedSource($event)"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="source"
                  [searchFn]="commonInputSearch"
                  placeholder="Where did you hear about PIQET from? *"
                  (clear)="clearSource()"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control accordion-search search-input"
                        id="inputValidation"
                        placeholder="Search..."
                        (input)="currency.filter($any($event.target).value)"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
              <div *ngIf="submitted && registerForm.get('source')?.invalid" class="input-error">
                {{ 'Please select an option' }}
              </div>
            </div>

            <div class="col-6 required" *ngIf="showCommentBox">
              <label for="Comment" class="sub-header-drpdown pb-2">{{ labelText }}</label>
              <div class="services-form comment-box">
                <textarea
                  formControlName="sourceComment"
                  cols="20"
                  id="Comment"
                  name="Comment"
                  rows="2"
                ></textarea>
              </div>
              <div
                *ngIf="submitted && registerForm.get('sourceComment')?.invalid"
                class="input-error"
              >
                Please add your comment
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-12">
              <div class="form-group">
                <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" formControlName="recaptcha">
                </ngx-recaptcha2>
                <div
                  *ngIf="submitted && registerForm.get('recaptcha')?.invalid"
                  class="input-error"
                >
                  <div class="recaptchafc">
                    <strong> {{ 'Captcha is not valid !' }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!isTrial">
            <div class="col-12">
              <div class="subscriptionNote">
                Please note that subscriptions are recurring and will automatically renew if not
                cancelled before the due date
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="threebtns">
                <button
                  class="cancelBtn"
                  routerLink="/login"
                  routerLinkActive="router-link-active"
                  type="button"
                >
                  Cancel
                </button>
                <button
                  [ngStyle]="{ visibility: !isTrial ? 'visible ' : 'hidden' }"
                  class="modelBtn"
                  type="button"
                  (click)="registerUser('purchase')"
                >
                  Purchase
                </button>
                <button
                  class="modelBtn"
                  id="trypiqet"
                  (click)="registerUser('trypiqet')"
                  type="button"
                  value="trypiqet"
                >
                  Try PIQET 15 days
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="copyright">
      <a href="http://www.lifecycles.com.au/" target="_blank">© Life Cycle Strategies Pty Ltd</a>
    </div>
  </div>
</div>
